var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1762 6.01607L13.4119 0.251786C13.2512 0.0910715 13.0342 0 12.8065 0H1.42794C0.953837 0 0.570801 0.383036 0.570801 0.857143V23.1429C0.570801 23.617 0.953837 24 1.42794 24H18.5708C19.0449 24 19.4279 23.617 19.4279 23.1429V6.62411C19.4279 6.39643 19.3369 6.17679 19.1762 6.01607ZM17.4512 7.01786H12.4101V1.97679L17.4512 7.01786ZM17.4994 22.0714H2.49937V1.92857H10.5887V7.71429C10.5887 8.01265 10.7072 8.2988 10.9182 8.50978C11.1291 8.72076 11.4153 8.83929 11.7137 8.83929H17.4994V22.0714ZM9.78509 14.8393H4.85652C4.73866 14.8393 4.64223 14.9357 4.64223 15.0536V16.3393C4.64223 16.4571 4.73866 16.5536 4.85652 16.5536H9.78509C9.90294 16.5536 9.99937 16.4571 9.99937 16.3393V15.0536C9.99937 14.9357 9.90294 14.8393 9.78509 14.8393ZM4.64223 11.4107V12.6964C4.64223 12.8143 4.73866 12.9107 4.85652 12.9107H15.1422C15.2601 12.9107 15.3565 12.8143 15.3565 12.6964V11.4107C15.3565 11.2929 15.2601 11.1964 15.1422 11.1964H4.85652C4.73866 11.1964 4.64223 11.2929 4.64223 11.4107Z",
    fill: "#E6ECF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.d5eba1b2d742700f11eb4be94876de82.svg";
export { ForwardRef as ReactComponent };